import {
  DataSnapshot,
  off,
  onValue,
  ref as firebaseRef,
} from 'firebase/database';
import { Ref, onUnmounted, ref } from 'vue';
import { db } from '../configs/firebase';

export function useRealtimeDatabaseObject<T>(path: string) {
  const item = ref<T | null>(null); // The ref is now typed as T | null
  const isLoading = ref(true);
  const error = ref<Error | null>(null);
  const objectRef = firebaseRef(db, path);

  // Listener callback
  const valueChange = (snapshot: DataSnapshot) => {
    try {
      const value = snapshot.val();
      item.value = Object.assign({}, value);
      isLoading.value = false;
    } catch (err) {
      error.value = err as Error;
      isLoading.value = false;
    } finally {
      isLoading.value = false;
    }
  };

  // Subscribe to the object
  onValue(objectRef, valueChange);

  // Unsubscribe when the component that uses this composable is unmounted
  onUnmounted(() => {
    off(objectRef, 'value', valueChange);
  });

  return {
    item: item as Ref<T | null>,
    isLoading,
    error,
  };
}
